// extracted by mini-css-extract-plugin
export default {"copy":"PmwtECGo9wfGBMP0uy71","common_bganimation":"QZsXFVPw9d6ijtzk9iBC"};